export default __webpack_public_path__ + "static/media/168.3bf76f09.svg";